import { render, staticRenderFns } from "./customer_detail.vue?vue&type=template&id=0d5671ec&"
import script from "./customer_detail.vue?vue&type=script&lang=js&"
export * from "./customer_detail.vue?vue&type=script&lang=js&"
import style0 from "./customer_detail.vue?vue&type=style&index=0&id=0d5671ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports